import {formatPhoneNumberIntl} from "react-phone-number-input";

export const convertPhone = (contact) =>{
    const isValidContact = formatPhoneNumberIntl(contact) === '' ? contact : formatPhoneNumberIntl(contact)
    return contact.slice(0, 4) === '+211' ? contact : isValidContact;
};